<mat-toolbar color="primary" class="apearAnimation flex-row flex content-between relative rounded-md">
  <span></span>
  <span class="example-spacer"></span>

  <button *ngIf="!logueado" mat-icon-button class="example-icon favorite-icon" aria-label="Example icon-button with heart icon" routerLink="login"  matTooltip="Iniciar Sesion" matTooltipPosition="below" matTooltipShowDelay="600">
    <mat-icon>login</mat-icon>
  </button>
<!--   <button *ngIf="!logueado" mat-icon-button class="example-icon favorite-icon" aria-label="Example icon-button with heart icon" routerLink="signup"  matTooltip="Registrarme" matTooltipPosition="below" matTooltipShowDelay="600">
    <mat-icon>account_circle</mat-icon>
  </button> -->

<span *ngIf="logueado">{{usrData.nombre}} </span>

  <button *ngIf="logueado" mat-icon-button class="example-icon favorite-icon" aria-label="Example icon-button with heart icon" routerLink="login"  matTooltip="Salir" matTooltipPosition="below" matTooltipShowDelay="600">
    <mat-icon>exit_to_app</mat-icon>
  </button>

</mat-toolbar>


<div fxLayout="column" class="flex-col flex justify-center overflow-hidden">
  <section
    style="
      background-color: rgb(255, 255, 255);
      padding-top: 60px;
      padding-bottom: 60px;
    "

class="flex-row flex justify-center overflow-hidden"
  >
    <div   
      class="divTitulos w-1/2 content-center items-center self-center"
     
    >
      <div  class="content-center items-center self-center">
        <h1 style="text-align: center;">Administración de acceso</h1>
      </div>  
      <div style="width: 100%; text-align: center;">
        <button mat-flat-button routerLink="login" color="primary" style="width: 50%; height: 50px;"   matTooltip="Buscar" matTooltipPosition="below" matTooltipShowDelay="600">Ingresar</button>
      </div>
    </div>

    <div
      fxFlex="50"
      fxFill
      fxLayout="column"
      fxLayoutAlign="center center"
      fxFlexOrder="2"
      fxFlexOrder.lt-sm="1"
      class="divImagen w-1/2 content-center"
    >
      <img
        src="../../assets/images/livasLogo.png"
        style="max-width: 50%"
      />
    </div>
  </section>

<!--   <section style="background-color: rgb(105, 105, 105); height: 600px;" class="lpsec2">
    Section2
  </section>

  <section style="background-color: rgb(255, 255, 255); height: 600px">
    Section3
  </section>

  <section style="background-color: rgb(105, 105, 105); height: 600px;" class="lpsec4">
    Section4
  </section> -->

<!--   <section style="background-color: #ffffff; height: 600px">
    Footer 
  </section> -->
</div>
